export default __webpack_public_path__ + "9c846431afdd27049a281956c67adc18.jpg";